/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_pedagogical': {
    width: 55.164,
    height: 54.501,
    viewBox: '0 0 55.164 54.501',
    data: '<g data-name="Grupo 1" _fill="#fff"><path pid="0" d="M21.851 17.76a8.641 8.641 0 01-1.79-2.605L8.637 20.976a10.786 10.786 0 00-5.192 7.137L.071 49.242a4.906 4.906 0 00.311 2.761l17.54-17.535a5.487 5.487 0 112.11 2.11L2.493 54.119a4.675 4.675 0 001.888.382 5.561 5.561 0 00.878-.071l21.129-3.373a10.788 10.788 0 007.138-5.193l5.82-11.424a8.635 8.635 0 01-2.6-1.789z"/><g data-name="Retângulo 1" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"><path pid="1" d="M22.744 12.608L35.352 0l19.812 19.813L42.556 32.42z" _stroke="none"/><path pid="2" _fill="none" d="M23.451 12.608l11.9-11.9 19.106 19.105-11.9 11.9z"/></g></g>'
  }
})
